import { IBusinessUnit } from './../models/line-of-business';
import axios, { AxiosResponse } from 'axios';

import { authFetch } from './fetch';

const baseUrl = '/api/Admin/BusinessUnits';

/**
 * Simplified CRUD/network ops interface for `IBankAccount` resources.
 */
export const IBusinessUnitAPI = {
  async getAll(): Promise<IBusinessUnit[]> {
    try {
      const response: AxiosResponse<IBusinessUnit[]> = await authFetch.get(baseUrl);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async upsert(upsertData: IBusinessUnit[]): Promise<IBusinessUnit[]> {
    try {
      const response: AxiosResponse<IBusinessUnit[]> = await authFetch.post(baseUrl, upsertData);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async delete(businessUnitId: number): Promise<void> {
    try {
      const response = await authFetch.delete(`${baseUrl}/${businessUnitId}`);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
    }
  },
};
